import { useState } from 'react'
import {
  createCashReportShare,
  downloadCashReportPdf,
  revokeCashReportShare,
} from '../../api/cashReport'

export default function CashReportShareMenu({ versionId }: { versionId?: string }) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  const [share, setShare] = useState<{ token: string; url: string } | null>(null)
  const [note, setNote] = useState('')

  async function onPdf() {
    setBusy(true)
    setNote('')
    try {
      const blob = await downloadCashReportPdf(versionId)
      const href = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = href
      a.download = 'cash-report.pdf'
      a.click()
      URL.revokeObjectURL(href)
    } catch {
      setNote('Could not download PDF')
    } finally {
      setBusy(false)
    }
  }

  async function onShare() {
    setBusy(true)
    setNote('')
    try {
      const res = await createCashReportShare(versionId)
      const data = res.data
      if (!data?.url || !data.token) throw new Error('share failed')
      setShare({ token: data.token, url: data.url })
      await navigator.clipboard.writeText(data.url)
      setNote('Link copied')
    } catch {
      setNote('Could not create link')
    } finally {
      setBusy(false)
    }
  }

  async function onRevoke() {
    if (!share?.token) return
    setBusy(true)
    try {
      await revokeCashReportShare(share.token)
      setShare(null)
      setNote('Link revoked')
    } catch {
      setNote('Could not revoke')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="cr-share-menu">
      <button type="button" className="cr-btn" data-testid="cr-download-pdf" disabled={busy} onClick={() => void onPdf()}>
        Download PDF
      </button>
      <button type="button" className="cr-btn" data-testid="cr-share" disabled={busy} onClick={() => setOpen((v) => !v)}>
        Share
      </button>
      {open ? (
        <div className="cr-share-pop" data-testid="cr-share-menu">
          <button type="button" className="cr-btn dark" disabled={busy} onClick={() => void onShare()}>
            Copy share link
          </button>
          <button type="button" className="cr-btn" disabled={busy || !share} onClick={() => void onRevoke()}>
            Revoke
          </button>
          {note ? <p data-testid="cr-share-note">{note}</p> : null}
        </div>
      ) : null}
    </div>
  )
}
